import { render, staticRenderFns } from "./EntityAssignments.vue?vue&type=template&id=677e0b3d"
import script from "./EntityAssignments.vue?vue&type=script&lang=js"
export * from "./EntityAssignments.vue?vue&type=script&lang=js"
import style0 from "./EntityAssignments.vue?vue&type=style&index=0&id=677e0b3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports